import type { TOption } from '@/types/common';

export enum EStationSetupStep {
  STATION_TYPE = 'STATION_TYPE',
  GENERAL_INFORMATION = 'GENERAL_INFORMATION',
  STATION_AMENITIES = 'STATION_AMENITIES',
  CONNECT_BANK = 'CONNECT_BANK',
  CONNECT_SYSTEM = 'CONNECT_SYSTEM',
  COMPLETE = 'COMPLETE',
}

export enum EFuelGrade {
  ECONOMY = 'ECONOMY',
  OCTANE_93 = '93',
  REGULAR = 'REGULAR',
  MID_GRADE = 'MIDGRADE',
  PREMIUM = 'PREMIUM',
  DIESEL = 'DIESEL',
  FAST_CHARGE = 'FAST_CHARGE',
  STD_CHARGE = 'STD_CHARGE',
}

export enum EElectricType {
  KWH_722 = '7 - 22 kWh',
}

export enum EFuelType {
  GASOLINE = 'GASOLINE',
  DIESEL = 'DIESEL',
  ELECTRIC = 'ELECTRIC',
}

export enum EPosSystem {
  VERIFONE = 'VERIFONE_COMMANDER',
  GILBARCO = 'GILBARCO_COMMANDER',
}

export enum EStationVariant {
  GASOLINE_AND_DIESEL = 'GAS_STATION',
  ELECTRIC = 'CHARGING_STATION',
  BOTH = 'GAS_EV',
}

export enum EPumpStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export enum EStationStatus {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
  PENDING = 'PENDING',
}

export enum EStationActor {
  POS = 'POS',
  USER = 'USER',
}

export enum EStationPendingReason {
  BANK_VERIFICATION_PENDING = 'BANK_VERIFICATION_PENDING',
  POS_FUEL_DETAILS_MISSING = 'POS_FUEL_DETAILS_MISSING',
  CHARGER_AND_FUEL_DETAILS_MISSING = 'CHARGER_AND_FUEL_DETAILS_MISSING',
}

export const POS_SUPPORT_URL = '#/support/pos';

export const POS_INSTRUCTIONS = {
  [EPosSystem.VERIFONE]: {
    fileName: 'verifone.pdf',
    url: `${window.env.CDN_HOST}/documents/stations/verifone/config/verifone_commander_setup.pdf`,
  },
  [EPosSystem.GILBARCO]: {
    fileName: 'gilbarco.pdf',
    url: `${window.env.CDN_HOST}/documents/stations/gilbarco/config/gilbarco_commander_setup.pdf`,
  },
};

export const POS_SYSTEMS: TOption<EPosSystem>[] = [
  { value: EPosSystem.VERIFONE, label: 'station.posSystems.verifone' },
  { value: EPosSystem.GILBARCO, label: 'station.posSystems.gilbarco' },
];

export const SUPPORTED_FUEL: TOption<EStationVariant>[] = [
  { value: EStationVariant.GASOLINE_AND_DIESEL, label: 'station.supports.gasAndDiesel' },
  { value: EStationVariant.ELECTRIC, label: 'station.supports.electric' },
  { value: EStationVariant.BOTH, label: 'station.supports.both' },
];

export const STATION_STATUSES: TOption<EStationStatus>[] = [
  { value: EStationStatus.ONLINE, label: 'stations.status.online' },
  { value: EStationStatus.OFFLINE, label: 'stations.status.offline' },
  { value: EStationStatus.PENDING, label: 'stations.status.pending' },
];
